export const VISIBILITY_STATUS_NOT_VISIBLE = 0
export const VISIBILITY_STATUS_VISIBLE = 1
export const VISIBILITY_STATUS_BETWEEN_DATES = 2
